import { Injectable } from "@angular/core"
import { Actions, createEffect, ofType } from "@ngrx/effects"
import { of } from "rxjs";
import { map, mergeMap, switchMap } from "rxjs/operators";
import { MessageHubService } from "src/app/shared/services/message-hub.service"
import * as LobbyStaffStatusActions from '../actions/lobby-staff-status.actions'
import * as MessageHubActions from 'src/app/state/actions/message-hub.actions';
import { LobbyService } from '../../../shared/services/lobby.service';

@Injectable()
export class LobbyStaffStatusEffects{
    constructor(
        private actions$: Actions,
        private lobbyService: LobbyService,
        private messageHubService: MessageHubService) { }


    lobbyStaffStatusGridData$ = createEffect(() =>{
        return this.actions$.pipe(
            ofType(LobbyStaffStatusActions.loadLobbyStaffGridData),
            switchMap(action => {
                this.messageHubService.subscribeToStaffStatusGridGroup(action.gridParams);
                return of(MessageHubActions.joinLobbyStaffStatusGridActionComplete());
            })
        )
    });
    loadImpersonateUserDetails$ = createEffect(() => {

        return this.actions$
            .pipe(
                ofType(LobbyStaffStatusActions.loadImpersonateUsers),
                mergeMap(action =>
                    this.lobbyService.getImpersonateUserDetails(action.locationId)
                        .pipe(

                            switchMap(res => of(
                                LobbyStaffStatusActions.updateImpersonateUsers({ imperSonateUserDetailinfo: res, showPopUp: action.showPopUp })

                            )),

                        )


                )
            );
    });

    loadLobbyGridViewData$ = createEffect(() => {
        return this.actions$
            .pipe(
                ofType(LobbyStaffStatusActions.updateLobbyGrid),
                switchMap(action => {
                    this.messageHubService.subscribeToLobbyEntryGridGroup(action.gridData);
                    return of(MessageHubActions.joinCentralLobbyGroupActionComplete());
                })
            );
    });
    loadImpersonateAssistDetails$ = createEffect(() => {

        return this.actions$
            .pipe(
                ofType(LobbyStaffStatusActions.loadImpersonateAssistDetails),
                mergeMap(action =>
                    this.lobbyService.getImpersonateAssistDetails()
                    .pipe(
                        map(imperSonateAssistDetailinfo => LobbyStaffStatusActions.updateImpersonatAssistDetails({imperSonateAssistDetailinfo}))
                    )

                )
            );
    });
}
